var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input-box" },
    [
      _vm.label !== null
        ? _c("label", { staticClass: "label-text" }, [
            _vm._v(_vm._s(_vm.label)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("validation-provider", {
        ref: "validationInput",
        attrs: { name: "baseInputEditValidationProvider", rules: _vm.rules },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var errors = ref.errors
              var valid = ref.valid
              return [
                _c(
                  "div",
                  {
                    staticClass: "form-group",
                    class: errors.length > 0 ? "error" : "",
                  },
                  [
                    _c("input", {
                      staticClass: "form-control",
                      attrs: { id: _vm.id, type: _vm.type, placeholder: "" },
                    }),
                    _vm._v(" "),
                    _c("small", { staticClass: "error-text" }, [
                      _vm._v(_vm._s(errors[0])),
                    ]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }